import HttpException from './HttpException';

export default class NotFoundHttpException extends HttpException {
    name = 'NotFoundHttpException';

    shouldBeReported = false;

    constructor(response: Response, message?: string) {
        super(response, message ?? 'Exceptions.not_found');
    }
}
